<template>
  <div id="message">
    <div class="box">
      <el-tabs type="border-card" @tab-click="tabChange">
        <el-tab-pane label="活动消息">
          <div class="table">
            <el-row :gutter="20" v-if="tabIndex==0">
              <el-col :span="12" v-for="(item,index) of tableData" :key="index">
                <div class="tab1Iteam">
                  <el-row>
                    <el-col :span="12" style="line-height:1.5em">
                      <div style="font-size:16px;">{{item.title}}</div>
                      <div
                        style="font-size:13px"
                        class="lv3Text"
                      >{{dayjs.unix(item.create_date).format("YYYY-MM-DD hh:mm:ss")}}</div>
                    </el-col>
                    <el-col :span="12" align="right" style="padding: 5px 10px;">
                      <div class="state1" v-if="item.status==1">进行中</div>
                      <div class="state2" v-else>已结束</div>
                    </el-col>
                  </el-row>
                  <div>
                    <el-image class="cover" :src="serve + '/'+item.image" fit="cover"></el-image>
                  </div>
                  <div
                    style="line-height:1.5em;height:41px;"
                    class="lv2Text"
                  >{{item.content.substr(0,55)}}{{item.content.length>55?' ...':''}}</div>
                  <div align="right">
                    <router-link :to="item.link">
                      <el-button type="text" size="small">查看详情 >></el-button>
                    </router-link>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
          <div class="pager" align="center">
            <el-pagination
              hide-on-single-page
              background
              layout="prev, pager, next"
              :total="total"
              @current-change="pageChange1"
            ></el-pagination>
          </div>
        </el-tab-pane>
        <el-tab-pane label="服务消息">
          <div v-if="tabIndex == 1">
            <div class="tab2-item" v-for="(item,index) of tableData" :key="index">
              <div class="title">
                <el-row>
                  <el-col :span="19">
                    <div>{{item.title}}</div>
                  </el-col>
                  <el-col :span="5" align="right" style="font-size:13px;">
                    <div>{{dayjs.unix(item.create_date).format("YYYY-MM-DD hh:mm:ss")}}</div>
                  </el-col>
                </el-row>
              </div>
              <div class="content">
                {{item.content.substr(0,120)}}{{item.content.length>120?' ...':''}}
                <div align="right">
                  <el-button type="text" size="small" @click="view2(item)">查看详情 >></el-button>
                </div>
              </div>
            </div>
            <div v-if="total>0" class="pager" align="center">
              <el-pagination
                background
                layout="prev, pager, next"
                :total="total"
                @current-change="pageChange1"
                hide-on-single-page
              ></el-pagination>
            </div>
            <div v-if="total==0" style="padding:50px 0;text-align:center" class="lv4Text">
              <img style="margin:0 auto" :src="serve + '/image/none/message.jpg'" alt />
            </div>
          </div>
        </el-tab-pane>
        <!-- <el-tab-pane label="子账户消息">
          <div v-if="signUp">
            <div>
              <div
                v-for="(item,index) of tableData"
                :key="index"
                style="border:1px solid #ddd;margin-bottom:20px;"
              >
                <div class="lv2Text" style="background-color:#eee;padding:10px">
                  {{item.title}}
                  <span
                    style="float:right;"
                  >{{dayjs.unix(item.create_date).format('YYYY-MM-DD hh:mm:ss')}}</span>
                </div>
                <div style="padding:20px 10px;" class="lv3Text">
                  <span>{{item.content.substr(0,120)}}</span>
                  <span style="float:right">
                    <el-link @click="openMsg(item)">查看详情>></el-link>
                  </span>
                </div>
              </div>
            </div>
            <div v-if="total>0" style="padding: 20px;" align="center">
              <el-pagination
                background
                layout="prev, pager, next"
                :total="total"
                @current-change="changePage"
              ></el-pagination>
            </div>
          </div>
          <div v-if="!signUp" style="padding-bottom:100px">
            <div style="width:500px;margin:0 auto;">
              <img :src="serve +'/image/none/noOpenHost.jpg'" style="width:500px;" />
            </div>
            <div class="lv3Text" align="center" style="font-size:18px;margin-top:50px">
              <div style="margin-bottom:5px;">您暂时没有权限使用经费管理功能，请联系</div>
              <div>
                24小时电话
                <span class="lv0Text">133 1168 8691</span> 开通后即可使用
              </div>
            </div>
          </div>
        </el-tab-pane>-->
      </el-tabs>
    </div>
    <el-dialog :visible.sync="viewDialog" width="50%" :before-close="handleClose" center>
      <span class="dialog" v-if="viewItem">
        <div class="title">
          <div class="t1 lv1Text">{{this.viewItem.title}}</div>
          <div
            class="t2 lv3Text"
          >{{dayjs.unix(this.viewItem.create_date).format("YYYY-MM-DD hh:mm:ss")}}</div>
        </div>
        <div class="lv2Text t3">{{viewItem.content}}</div>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="viewDialog = false">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog :visible.sync="msgDialog" width="600px" center>
      <div>
        <div align="center" style="margin-bottom:10px;font-size:14px">
          <div style="margin-bottom:5px">{{msg.title}}</div>
          <div
            class="lv3Text"
            style="font-size:12px"
          >{{dayjs.unix(msg.create_date).format('YYYY-MM-DD hh:mm:ss')}}</div>
        </div>
        <div style="border-top:1px solid #ddd;padding-top:20px;">{{msg.content}}</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="msgDialog = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      serve: this.$store.state.serve,

      msg: "",
      msgDialog: false,
      tableData: null,
      total: 0,
      page: 1,
      tabIndex: 0,
      viewItem: null,
      viewDialog: false,
      signUp: null
    };
  },
  activated() {
    this.$store.state.user_location = "消息通知";
  },
  created() {
    this.initTab1();
  },
  methods: {
    openMsg(msg) {
      this.msg = msg;
      this.msgDialog = true;
    },
    changePage(p) {
      this.axios
        .get(this.serve + "/personal/children_message", {
          params: {
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token"),
            page: p
          }
        })
        .then(res => {
          if (res.data.data) {
            this.tableData = res.data.data.results;
            this.total = res.data.data.total;
          } else {
            this.tableData = [];
            this.total = 0;
          }
        });
    },
    handleClose(done) {
      this.viewItem = null;
      done();
    },
    tabChange(tab) {
      this.page = 1;
      this.tabIndex = tab.paneName;
      this.initTab1();
    },
    view2(item) {
      this.viewItem = item;
      this.viewDialog = true;
    },
    initTab1() {
      this.tableData = null;
      var url = "";
      if (this.tabIndex == 0) {
        url = this.serve + "/personal/activity_message";
      } else if (this.tabIndex == 1) {
        url = this.serve + "/personal/serve_message";
      } else if (this.tabIndex == 2) {
        url = this.serve + "/personal/children_message";
      }
      this.axios
        .get(url, {
          params: {
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token"),
            page: this.page
          }
        })
        .then(res => {
          if (res.data.data) {
            this.tableData = res.data.data.results;
            this.total = res.data.data.total;
          } else if (
            res.data.msg == "未开通主账户:如需开通请联系24小时客服:13311688691"
          ) {
            this.signUp = false;
          } else {
            this.tableData = [];
            this.total = 0;
          }
        });
    },
    pageChange1(v) {
      this.page = v;
      this.initTab1();
    }
  }
};
</script>
<style lang="scss">
#message {
  .dialog {
    .t3 {
      margin-top: 30px;
    }
    .t1 {
      font-size: 18px;
      margin-bottom: 10px;
    }
    .t2 {
      margin-bottom: 20px;
    }
    .title {
      border-bottom: 1px solid #ddd;
      text-align: center;
    }
  }
  .tab2-item {
    border: 1px solid #ddd;
    .title {
      background-color: #f9f9f9;
      color: #333;
      padding: 10px 15px;
    }
    .content {
      padding: 20px 15px 10px 15px;
      line-height: 1.5em;
    }
    margin-bottom: 20px;
  }
  .state1 {
    background-color: #f33934;
    color: #fff;
    display: inline-block;
    border-radius: 20px;
    width: 80px;
    padding: 8px 0;
    text-align: center;
  }
  .state2 {
    background-color: #808080;
    color: #fff;
    display: inline-block;
    border-radius: 20px;
    width: 80px;
    padding: 8px 0;
    text-align: center;
  }
  .cover {
    height: 150px;
    width: 100%;
    margin: 10px 0;
  }
  .tab1Iteam {
    border: 1px solid #ddd;
    padding: 5px 10px;
    margin-bottom: 20px;
  }
  .box {
    background-color: #fff;
  }
  .table {
    padding: 20px;
  }
}
</style>